import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

export const types = {
  REQUEST_TRANSACTIONS: 'transaction/REQUEST_TRANSACTIONS',
  RECEIVE_TRANSACTIONS: 'transaction/RECEIVE_TRANSACTIONS',
};

const requestTransactions = () => ({ type: types.REQUEST_TRANSACTIONS });
const receiveTransactions = (data) => ({ type: types.RECEIVE_TRANSACTIONS, transactions: data });

/**
 * GET /v{version}/user/transactions
 * Returns UserTransactionDto[] for the signed-in user (type labels come from BE).
 */
export const fetchTransactions = () => async (dispatch) => {
  dispatch(requestTransactions());
  const url = `${API_BASE}user/transactions`;
  try {
    const res = await axios.get(url);
    dispatch(receiveTransactions(Array.isArray(res.data) ? res.data : []));
  } catch (err) {
    dispatch(receiveTransactions([]));
  }
};

/** PATCH /v{version}/transactions/{transactionId}/renew */
export const renewTransaction = (transactionId, data = {}) => async (dispatch) => {
  const url = `${API_BASE}transactions/${transactionId}/renew`;
  try {
    const res = await axios.patch(url, data);
    dispatch(fetchTransactions());
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
